/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Dvc_Search_Data_LabelInputs */

const en_task_dvc_search_data_label = /** @type {(inputs: Task_Dvc_Search_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data to search`)
};

const pt_br2_task_dvc_search_data_label = /** @type {(inputs: Task_Dvc_Search_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dado a ser pesquisado`)
};

/**
* | output |
* | --- |
* | "Data to search" |
*
* @param {Task_Dvc_Search_Data_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_dvc_search_data_label = /** @type {((inputs?: Task_Dvc_Search_Data_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Dvc_Search_Data_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_dvc_search_data_label(inputs)
	return pt_br2_task_dvc_search_data_label(inputs)
});